import type { ReactNode } from 'react';

type MailActionBarProps = {
  start?: ReactNode;
  end?: ReactNode;
};

export default function MailActionBar({ start, end }: MailActionBarProps) {
  return (
    <div className="fixed right-0 bottom-0 left-[250px] z-10 flex h-[70px] items-center justify-between gap-md bg-white px-lg shadow-layer3">
      <div className="flex items-center gap-xs">{start}</div>
      <div className="flex items-center gap-xs">{end}</div>
    </div>
  );
}
